import * as Types from '../../../doorhub-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ViewLockerFragment = { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, pickupBefore?: any | null } | null };

export type SelectLockerSystemQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
}>;


export type SelectLockerSystemQuery = { __typename?: 'Query', user?: { __typename?: 'User', lockersystems: { __typename?: 'UserLockersystemsConnection', lockersystems: Array<{ __typename?: 'Lockersystem', id: string, name?: string | null }> } } | null };

export type SelectUserQueryVariables = Types.Exact<{
  input: Types.UserSearchOptions;
}>;


export type SelectUserQuery = { __typename?: 'Query', users: { __typename?: 'UsersConnection', totalCount?: number | null, users: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, userName?: string | null }> } };

export type SelectUserGroupsQueryVariables = Types.Exact<{
  lockersystemId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type SelectUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, lockersystemId?: string | null, users: Array<{ __typename?: 'User', id: string }> }> };

export type SelectLockerQueryVariables = Types.Exact<{
  lockersystemId: Types.Scalars['ID'];
}>;


export type SelectLockerQuery = { __typename?: 'Query', lockersystem?: { __typename?: 'Lockersystem', lockerGroups: Array<{ __typename?: 'LockerGroup', id: string, name: string, lainaamo: boolean, lockerUnits: Array<{ __typename?: 'LockerUnit', id?: string | null, lockerNodes: Array<{ __typename?: 'LockerNode', id?: string | null, leftUpLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, pickupBefore?: any | null } | null } | null, rightUpLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, pickupBefore?: any | null } | null } | null, leftDownLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, pickupBefore?: any | null } | null } | null, rightDownLocker?: { __typename?: 'Locker', id: string, name: number, width?: number | null, height?: number | null, depth?: number | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string, name?: string | null, activeRenting?: { __typename?: 'Renting', id: string, returnItemBefore?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null, delivery?: { __typename?: 'Delivery', id: string, description?: string | null, pickupBefore?: any | null } | null } | null }> }>, lockers: Array<{ __typename?: 'Locker', id: string, name: number, status?: Types.LockerStatus | null, terminal?: boolean | null, item?: { __typename?: 'Item', id: string } | null, delivery?: { __typename?: 'Delivery', id: string } | null }> }> } | null };

export const ViewLockerFragmentDoc = gql`
    fragment ViewLocker on Locker {
  id
  name
  width
  height
  depth
  terminal
  item {
    id
    name
    activeRenting {
      id
      returnItemBefore
      user {
        id
        name
        email
      }
    }
  }
  delivery {
    id
    description
    pickupBefore
  }
}
    `;
export const SelectLockerSystemDocument = gql`
    query SelectLockerSystem($userId: ID!) {
  user(userId: $userId) {
    lockersystems(opt: {rentingAllowed: true, deliveryAllowed: true}) {
      lockersystems {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSelectLockerSystemQuery__
 *
 * To run a query within a React component, call `useSelectLockerSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectLockerSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectLockerSystemQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSelectLockerSystemQuery(baseOptions: Apollo.QueryHookOptions<SelectLockerSystemQuery, SelectLockerSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectLockerSystemQuery, SelectLockerSystemQueryVariables>(SelectLockerSystemDocument, options);
      }
export function useSelectLockerSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectLockerSystemQuery, SelectLockerSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectLockerSystemQuery, SelectLockerSystemQueryVariables>(SelectLockerSystemDocument, options);
        }
export type SelectLockerSystemQueryHookResult = ReturnType<typeof useSelectLockerSystemQuery>;
export type SelectLockerSystemLazyQueryHookResult = ReturnType<typeof useSelectLockerSystemLazyQuery>;
export type SelectLockerSystemQueryResult = Apollo.QueryResult<SelectLockerSystemQuery, SelectLockerSystemQueryVariables>;
export const SelectUserDocument = gql`
    query SelectUser($input: UserSearchOptions!) {
  users(input: $input) {
    totalCount
    users {
      id
      name
      email
      userName
    }
  }
}
    `;

/**
 * __useSelectUserQuery__
 *
 * To run a query within a React component, call `useSelectUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectUserQuery(baseOptions: Apollo.QueryHookOptions<SelectUserQuery, SelectUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectUserQuery, SelectUserQueryVariables>(SelectUserDocument, options);
      }
export function useSelectUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectUserQuery, SelectUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectUserQuery, SelectUserQueryVariables>(SelectUserDocument, options);
        }
export type SelectUserQueryHookResult = ReturnType<typeof useSelectUserQuery>;
export type SelectUserLazyQueryHookResult = ReturnType<typeof useSelectUserLazyQuery>;
export type SelectUserQueryResult = Apollo.QueryResult<SelectUserQuery, SelectUserQueryVariables>;
export const SelectUserGroupsDocument = gql`
    query SelectUserGroups($lockersystemId: ID) {
  userGroups(lockersystemId: $lockersystemId) {
    id
    name
    lockersystemId
    users {
      id
    }
  }
}
    `;

/**
 * __useSelectUserGroupsQuery__
 *
 * To run a query within a React component, call `useSelectUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectUserGroupsQuery({
 *   variables: {
 *      lockersystemId: // value for 'lockersystemId'
 *   },
 * });
 */
export function useSelectUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SelectUserGroupsQuery, SelectUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectUserGroupsQuery, SelectUserGroupsQueryVariables>(SelectUserGroupsDocument, options);
      }
export function useSelectUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectUserGroupsQuery, SelectUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectUserGroupsQuery, SelectUserGroupsQueryVariables>(SelectUserGroupsDocument, options);
        }
export type SelectUserGroupsQueryHookResult = ReturnType<typeof useSelectUserGroupsQuery>;
export type SelectUserGroupsLazyQueryHookResult = ReturnType<typeof useSelectUserGroupsLazyQuery>;
export type SelectUserGroupsQueryResult = Apollo.QueryResult<SelectUserGroupsQuery, SelectUserGroupsQueryVariables>;
export const SelectLockerDocument = gql`
    query SelectLocker($lockersystemId: ID!) {
  lockersystem(lockersystemId: $lockersystemId) {
    lockerGroups(lainaamo: true) {
      id
      name
      lainaamo
      lockerUnits {
        id
        lockerNodes {
          id
          leftUpLocker {
            ...ViewLocker
          }
          rightUpLocker {
            ...ViewLocker
          }
          leftDownLocker {
            ...ViewLocker
          }
          rightDownLocker {
            ...ViewLocker
          }
        }
      }
      lockers {
        id
        name
        status
        terminal
        item {
          id
        }
        delivery {
          id
        }
      }
    }
  }
}
    ${ViewLockerFragmentDoc}`;

/**
 * __useSelectLockerQuery__
 *
 * To run a query within a React component, call `useSelectLockerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectLockerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectLockerQuery({
 *   variables: {
 *      lockersystemId: // value for 'lockersystemId'
 *   },
 * });
 */
export function useSelectLockerQuery(baseOptions: Apollo.QueryHookOptions<SelectLockerQuery, SelectLockerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectLockerQuery, SelectLockerQueryVariables>(SelectLockerDocument, options);
      }
export function useSelectLockerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectLockerQuery, SelectLockerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectLockerQuery, SelectLockerQueryVariables>(SelectLockerDocument, options);
        }
export type SelectLockerQueryHookResult = ReturnType<typeof useSelectLockerQuery>;
export type SelectLockerLazyQueryHookResult = ReturnType<typeof useSelectLockerLazyQuery>;
export type SelectLockerQueryResult = Apollo.QueryResult<SelectLockerQuery, SelectLockerQueryVariables>;